import type { BoardOrder } from '../data'

/**
 * A build order's units as one bar — built · on the bench · ready to start ·
 * waiting on parts, left to right — with the counts underneath. Today and Build
 * draw the same bar, so an order looks the same wherever it is met.
 */
export function BuildProgress({ order: o, legend = true }: { order: BoardOrder; legend?: boolean }): JSX.Element {
  const waiting = Math.max(0, o.quantity - o.built - o.inProgress - o.ready)
  const parts = [
    { n: o.built, cls: 'built', label: 'built' },
    { n: o.inProgress, cls: 'bench', label: 'on the bench' },
    { n: o.ready, cls: 'ready', label: 'ready to start' },
    { n: waiting, cls: 'waiting', label: 'waiting on parts' },
  ]
  return (
    <div className="stack" style={{ gap: 8 }}>
      <span className="progress" aria-hidden="true">
        {parts
          .filter((p) => p.n > 0)
          .map((p) => (
            <span key={p.cls} className={`progress__part progress__part--${p.cls}`} style={{ flexGrow: p.n }} />
          ))}
      </span>
      {legend ? (
        <span className="progress-legend">
          {parts.map((p) => (
            <span key={p.cls} className="progress-legend__item">
              <span className={`progress-legend__swatch progress__part--${p.cls}`} aria-hidden="true" />
              <span className="figure">{p.n}</span> {p.label}
            </span>
          ))}
        </span>
      ) : null}
    </div>
  )
}
